// extracted by mini-css-extract-plugin
export default {"container":"p-Klo","time":"sn76o","title":"rQqd3","chevron":"kXLyK"};